import { isHidden as n } from "./ghl-ui.es1552.js";
var i = function(e) {
  if (n(e))
    return 1 / 0;
  for (var t = 0, r = e.parentNode; r; )
    t += 1, r = r.parentNode;
  return t;
};
export {
  i as calculateDepthForNode
};
